import { render, staticRenderFns } from "./ProfileMenu.vue?vue&type=template&id=c0fda992&scoped=true"
import script from "./ProfileMenu.vue?vue&type=script&lang=js"
export * from "./ProfileMenu.vue?vue&type=script&lang=js"
import style0 from "./ProfileMenu.vue?vue&type=style&index=0&id=c0fda992&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fda992",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0fda992')) {
      api.createRecord('c0fda992', component.options)
    } else {
      api.reload('c0fda992', component.options)
    }
    module.hot.accept("./ProfileMenu.vue?vue&type=template&id=c0fda992&scoped=true", function () {
      api.rerender('c0fda992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/profile/ProfileMenu.vue"
export default component.exports